<template>

    <span>
        <Byk v-if="device.id == 71" :device="device" />
        <Buffer v-if="device.id == 62" :device="device" />
        <Fakkel v-if="device.id == 61" :device="device" />
    </span>

</template>

<script>

import Byk from '@/apps/ijskoud/visuals/Byk.vue' ;
import Buffer from '@/apps/ijskoud/visuals/Buffer.vue' ;
import Fakkel from '@/apps/ijskoud/visuals/Fakkel.vue' ;

export default {
    
    components: {
        Byk,
        Buffer,
        Fakkel,
    },
    props: {
        device: {
            type: Object,
            required: false,
            default: null
        },
    }

}

</script>